'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-340/node_modules/@eliadmin/core/src/pages/(profile)/favorites/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-340/node_modules/@eliadmin/core/src/pages/(profile)/favorites/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/1652f9dc6f11"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

